import { Navigate, Route, Routes } from "react-router-dom";
import {
  AdminPage,
  CreateUserPage,
  CreateProfilePage,
  ProfilesTablePage,
  UsersTablePage,
  EditUserPage,
  EditProfilePage,
  CreateCustomerPage,
  TableServicesPage,
  CreateServicesPage,
  EditServicesPage,
  EditCustomerPage,
  ConversationsPage,
  ChatPage,
} from "../pages";
import { NavSideBarComponent } from "../components";
import { useState } from "react";
import { MenuLayout } from "../layouts";
import { useDispatch } from "react-redux";
import { getInformation } from "../../store/auth";
import { useChatNotifications } from "../../hooks";

export const AdminRouter = () => {
  const [isActiveNavLayout, setActiveNavLayout] = useState(false);
  const dispatch = useDispatch();
  useChatNotifications();
  dispatch(getInformation());
  return (
    <>
      <NavSideBarComponent
        isActiveNavLayout={isActiveNavLayout}
        setActiveNavLayout={setActiveNavLayout}
      />
      <div
        className={` ${
          isActiveNavLayout
            ? "ml-64 w-main-menu-active transition-all"
            : "ml-24 w-main-menu transition-all"
        } `}
      >
        <MenuLayout>
          <Routes>
            <Route path="/" element={<AdminPage />}></Route>
            <Route path="/new-user" element={<CreateUserPage />}></Route>
            <Route path="/users/:id" element={<EditUserPage />} />
            <Route path="/profiles" element={<ProfilesTablePage />} />
            <Route path="/profile" element={<CreateProfilePage />} />
            <Route path="/profile/:id" element={<EditProfilePage />} />
            <Route path="/customers" element={<UsersTablePage />} />
            <Route path="/customer" element={<CreateCustomerPage />} />
            <Route path="/customer/:id" element={<EditCustomerPage />} />
            <Route path="/services" element={<TableServicesPage />} />
            <Route path="/service" element={<CreateServicesPage />} />
            <Route path="/services/:id" element={<EditServicesPage />} />
            <Route path="/chats" element={<ConversationsPage />} />
            <Route path="/chat/:id/:idConversation" element={<ChatPage />} />
            <Route path="/*" element={<Navigate to="main" />} />
          </Routes>
        </MenuLayout>
      </div>
    </>
  );
};
